import { createReducer, on } from '@ngrx/store';
import * as fromActions from './actions';
import { Conversation } from '@repo/shared/src/services/messaging-service/messaging-service.types';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { state } from '@angular/animations';

export interface conversationState extends EntityState<Conversation> {
  // additional entities state properties
  conversationSelected: Conversation | null;
  isLoading: boolean;
  isLoaded: boolean;
  isDeleting: boolean;
  error: any | null;
}

export const adapter: EntityAdapter<Conversation> = createEntityAdapter<Conversation>({
  selectId: c => c.id,
  sortComparer: (a, b) => {
    const dateA = a.lastUpdateDate ? a.lastUpdateDate : a.creationDate;
    const dateB = b.lastUpdateDate ? b.lastUpdateDate : b.creationDate;
    return dateA < dateB ? 1 : -1;
  },
});

export const initialState: conversationState = adapter.getInitialState({
  // additional entity state properties
  conversationSelected: null,
  isLoading: false,
  isLoaded: false,
  isDeleting: false,
  error: null,
});

export const reducer = createReducer(
  initialState,
  on(fromActions.setConversationSelected, (state, { conversationSelected }) => ({ ...state, conversationSelected })),
  on(fromActions.getConversationList, (state, { isLoadingNeeded }) => ({
    ...state,
    isLoading: isLoadingNeeded,
    isLoaded: !isLoadingNeeded,
  })),
  on(fromActions.getConversationListSuccess, (state, { conversationList }) =>
    adapter.setAll(conversationList, { ...state, isLoading: false, isLoaded: true }),
  ),
  on(fromActions.getConversationListFailed, (state, { error, isLoadingNeeded }) => ({
    ...state,
    error,
    isLoading: false,
    isLoaded: isLoadingNeeded ? false : state.isLoaded,
  })),
  on(fromActions.updateConversationSuccess, (state, { conversationUpdated }) =>
    adapter.updateOne(conversationUpdated, state),
  ),
  on(fromActions.deleteConversation, state => ({ ...state, isDeleting: true, error: null })),
  on(fromActions.deleteConversationSuccess, (state, { conversationId }) =>
    adapter.removeOne(conversationId, { ...state, isDeleting: false, conversationSelected: null }),
  ),
  on(fromActions.deleteConversationFailed, (state, { error }) => ({
    ...state,
    error,
    isDeleting: false,
  })),
  on(fromActions.postConversation, state => ({ ...state, error: null })),
  on(fromActions.postConversationSuccess, (state, { conversation }) => adapter.addOne(conversation, { ...state })),
  on(fromActions.postConversationFailed, (state, { error }) => ({ ...state, error })),
);

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

// select the array of conversations ids
export const selectConversationsIds = selectIds;

// select the dictionary of conversation entities
export const selectConversationsEntities = selectEntities;

// select the array of conversations
export const selectAllConversations = selectAll;

// select the total conversations count
export const selectConversationTotalCount = selectTotal;
